import { render } from "./CoManagerHeader.vue?vue&type=template&id=ba52eac8&scoped=true"
import script from "./CoManagerHeader.vue?vue&type=script&lang=js"
export * from "./CoManagerHeader.vue?vue&type=script&lang=js"

import "./CoManagerHeader.vue?vue&type=style&index=0&id=ba52eac8&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba52eac8"]])

export default __exports__